<template>
  <div class="filter-section">
    <div class="filter-row row-actions">
      <div class="filter-item">
        <label>报告时间：</label>
        <el-select
          v-model="internalFilters.quarter"
          placeholder="全部"
          clearable
          multiple
          collapse-tags
          @clear="() => { internalFilters.quarter = []; }"
        >
          <el-option
            v-for="option in options.quarter"
            :key="option"
            :label="option"
            :value="option"
          />
        </el-select>
      </div>
      <div class="action-buttons">
        <button class="confirm-btn" @click="confirmFilters" :disabled="isConfirmLoading">
          <LoadingSpinner v-if="isConfirmLoading" :visible="true" :inline="true" text="筛选中..." />
          <span v-else>确认</span>
        </button>
        <button class="clear-all-btn" @click="clearAllFilters" :disabled="isClearLoading">
          <LoadingSpinner v-if="isClearLoading" :visible="true" :inline="true" text="清除中..." />
          <span v-else>清除筛选</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export default {
  name: 'LChartFilterSection',
  components: {
    LoadingSpinner
  },
  props: {
    filters: {
      type: Object,
      default: () => ({ quarter: [] })
    },
    options: {
      type: Object,
      default: () => ({ quarter: [] })
    }
  },
  data() {
    return {
      internalFilters: { quarter: [] },
      isConfirmLoading: false,
      isClearLoading: false
    };
  },
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (Array.isArray(newVal.quarter)) {
          this.internalFilters.quarter = [...newVal.quarter];
        } else if (newVal.quarter) {
          this.internalFilters.quarter = [newVal.quarter];
        } else {
          this.internalFilters.quarter = [];
        }
      }
    }
  },
  methods: {
    confirmFilters() {
      this.isConfirmLoading = true;
      this.$emit('filter-change', { ...this.internalFilters });
      setTimeout(() => {
        this.isConfirmLoading = false;
      }, 500);
    },
    clearAllFilters() {
      this.isClearLoading = true;
      this.internalFilters.quarter = [];
      this.$emit('filter-change', { quarter: [] });
      setTimeout(() => {
        this.isClearLoading = false;
      }, 500);
    }
  }
};
</script>

<style scoped>
.filter-section {
  background-color: white;
  padding: 20px 30px;
  border-radius: 8px;
  margin: 0 30px 20px 30px;
}

.filter-row {
  display: flex;
  gap: 160px;
  align-items: center;
}

.filter-row.row-actions {
  justify-content: space-between;
  width: 100%;
  gap: 24px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 0 1 auto;
}

.filter-item label {
  font-weight: bold;
  color: #2e3968;
  white-space: nowrap;
  width: 130px;
  text-align: left;
}

.filter-item >>> .el-select {
  min-width: 200px;
  width: 250px;
  height: 34px;
  line-height: 32px;
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 0;
  box-sizing: border-box;
}

.filter-item >>> .el-select .el-input__inner {
  border: none !important;
  height: 100% !important;
  line-height: inherit !important;
  padding-left: 10px;
  padding-right: 30px;
  box-sizing: border-box;
}

.filter-item >>> .el-select .el-input .el-select__caret {
  line-height: inherit;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 20px;
}

.confirm-btn,
.clear-all-btn {
  background-color: #2e3968;
  color: white;
  padding: 0 22px;
  border: 1px solid #2e3968;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  min-width: 100px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.confirm-btn:hover,
.clear-all-btn:hover {
  background-color: white;
  color: #2e3968;
}

.confirm-btn:disabled,
.clear-all-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  color: #666;
}

.confirm-btn:disabled:hover,
.clear-all-btn:disabled:hover {
  background-color: #cccccc;
  color: #666;
}

@media (max-width: 992px) {
  .filter-section {
    padding: 15px;
    margin: 0 15px 15px 15px;
  }

  .filter-row.row-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .filter-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .filter-item label {
    width: auto;
  }

  .filter-item >>> .el-select {
    width: 100%;
    min-width: unset;
  }

  .action-buttons {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 10px;
  }

  .confirm-btn,
  .clear-all-btn {
    width: 100%;
    padding: 12px 0;
    font-size: 15px;
  }
}
</style>
